export const exterior_view02ImageOptions = {
  angle: 'exterior_view02',
  staticOptions: {
    BowSpritRailing: 1,
    BowSpritLadder: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    MastAndBoom: 1,
    Wheel: 1,
    Sprayhood: 1
  },
  mattes: [
    {
      option: 'BowSpritRailing',
      dependency: null
    },
    {
      option: 'BowSpritLadder',
      dependency: null
    },
    {
      option: 'Deck',
      dependency: 'Wheel'
    },
    {
      option: 'TeakOnSideDecks',
      dependency: 'Deck'
    },
    {
      option: 'TeakOnCoachroof',
      dependency: 'Deck'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/X49MK2/views/exterior_view02.js